import { IEpisode } from '@redmedical/datamodels/shared-datamodels';

import { EntitySavedOnServerWithId } from '../models/entity-saved-on-server-with-id.type';
import { MakeRequired } from '../utility/make-required';
import { optional } from '../utility/optional';

import { EntityWithRelations } from './entity-with-relations.type';

export const EPISODE_WITH_PATIENT_AND_DOCTOR_QUERY = {
  id: '' as MakeRequired<IEpisode, 'id'>['id'],
  Doctor: {},
  Patient: {},
  Location: optional(),
  DMP: optional(),
  GoaeContractType: optional(),
  PrivateEpisodenArt: optional(),
} as const;

export type EpisodeWithPatientAndDoctor = EntityWithRelations<
  EntitySavedOnServerWithId<IEpisode>,
  typeof EPISODE_WITH_PATIENT_AND_DOCTOR_QUERY
>;
